import { render, staticRenderFns } from "./CustomerProfilePage.vue?vue&type=template&id=1c0ebfda&scoped=true&"
import script from "./CustomerProfilePage.vue?vue&type=script&lang=js&"
export * from "./CustomerProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfilePage.vue?vue&type=style&index=0&id=1c0ebfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ebfda",
  null
  
)

export default component.exports